import React, { useState, useEffect } from 'react';

const FloatingComplaint = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
    
  };

  return (
    React.createElement(React.Fragment, null,
      <button 
        className="btn btn-danger shadow-lg"
        onClick={toggleModal}
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          width: '65px',
          height: '65px',
          borderRadius: '50%',
          backgroundColor: '#dc3545',
          color: '#ffffff',
          border: 'none',
          zIndex: 99999,
          cursor: 'pointer',
          fontSize: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Layanan Pengaduan"
      >
        <i className="fas fa-exclamation-circle"></i>
      </button>,
      

      showModal && (
        <div 
          className="modal fade show" 
          onClick={toggleModal}
          style={{ 
            display: 'block', 
            backgroundColor: 'rgba(0,0,0,0.6)', 
            zIndex: 100000,
            position: 'fixed',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            overflowY: 'auto'
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ zIndex: 100001 }}>
            <div className="modal-content text-dark" style={{ backgroundColor: '#ffffff' }}> 
              <div className="modal-header">
                <h5 className="modal-title fw-bold text-danger">
                  <i className="fas fa-bullhorn me-2"></i> Informasi Layanan Pengaduan
                </h5>
                {/* <button type="button" className="btn-close" onClick={toggleModal}></button> */}
              </div>
                 <div className="modal-body text-start" style={{ lineHeight: '1.6', fontSize: '15px' }}>
                <p>
                  Diinformasikan kepada Bapak/Ibu Pelaku Usaha BPPMHKP, berikut disampaikan saluran resmi sarana Pengaduan lingkup BPPMHKP:
                </p>
                <div className="my-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                      <i className="fab fa-whatsapp"></i>
                    </div>
                    <div>
                      <strong className="d-block text-muted" style={{ fontSize: '12px' }}>WhatsApp Resmi</strong>
                      <a href="http://wa.me/6282221007557" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-bold text-success">
                        0822-2100-7557
                      </a>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', fontSize: '18px' }}>
                      <i className="fas fa-globe"></i>
                    </div>
                    <div>
                      <strong className="d-block text-muted" style={{ fontSize: '12px' }}>Website WBS KKP</strong>
                      <a href="http://wbs.kkp.go.id" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-bold text-primary">
                        wbs.kkp.go.id
                      </a>
                    </div>
                  </div>
                </div>
                <p className="mb-0 text-muted" style={{ fontStyle: 'italic' }}>
                  Atas perhatiannya diucapkan terimakasih.
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={toggleModal} >Tutup</button>
              </div>
            </div>
          </div>
        </div>
      )
    )
  );
};

export default FloatingComplaint;